
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import ServicesSection from './components/ServicesSection';
import IndustryExpertiseSection from './components/IndustryExpertiseSection';
import SpecializedServicesSection from './components/SpecializedServicesSection';
import ContactFormSection from './components/ContactFormSection';

const OSHAConsultingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="OSHA Consulting Services - HP Inc Consulting Services | Compliance Experts"
        description="Professional OSHA compliance consulting services for construction and industrial companies. Expert safety audits, compliance assessments, and regulatory guidance in New York and Northeast region."
        keywords="OSHA consulting, OSHA compliance, safety consulting, workplace safety audit, OSHA compliance assessment, safety regulations, construction safety consulting, industrial safety consulting, OSHA violations, safety compliance"
        canonical="https://hpincconsultant.com/osha-consulting"
        ogTitle="OSHA Consulting Services - Professional Safety Compliance"
        ogDescription="Expert OSHA compliance consulting and safety auditing services for construction and industrial companies across the Northeast."
        ogUrl="https://hpincconsultant.com/osha-consulting"
      />
      <Header />
      <main>
        <HeroSection />
        <IntroSection />
        <WhyChooseUsSection />
        <ServicesSection />
        <IndustryExpertiseSection />
        <SpecializedServicesSection />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
};

export default OSHAConsultingPage;
